import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { initializeDemoMocking, cleanupDemoMocking, setDemoMode } from '@Shared/utils/demoMsw';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'authentication',
    component: () => import('@CCS/views/AuthenticationView.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@CCS/views/DashboardView.vue'),
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('@CCS/views/demo/DemoDashboardView.vue'),
  },
  {
    path: '/demo/new',
    name: 'newDemo',
    component: () => import('@CCS/views/demo/NewDemoDashboardView.vue'),
  },
  {
    path: '/demo/new/csat/',
    name: 'newDemoCsat',
    component: () => import('@CCS/views/demo/NewCsatDemoDashboardView.vue'),
  },
  {
    path: '/demo/skeleton',
    name: 'skeletonDemo',
    component: () => import('@CCS/views/demo/SkeletonDemoDashboardView.vue'),
  },
  {
    path: '/demo/skeleton/new',
    name: 'newSkeletonDemo',
    component: () => import('@CCS/views/demo/NewSkeletonDemoDashboardView.vue'),
  },
  {
    path: '/demo/client',
    name: 'clientDemo',
    component: () => import('@CCS/views/demo/ClientDemoDashboardView.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(location.pathname.startsWith('/ccs') ? 'ccs' : undefined),
  routes,
});

// Initialize demo mocking for demo routes
router.beforeEach((to, from) => {
  // If entering a demo route, initialize demo mocking
  if (to.path.startsWith('/demo') && !from.path.startsWith('/demo')) {
    setDemoMode(true);
    initializeDemoMocking();
  }
  // If leaving demo routes, cleanup demo mocking
  else if (!to.path.startsWith('/demo') && from.path.startsWith('/demo')) {
    setDemoMode(false);
    cleanupDemoMocking();
  }
});

export default router;
